import { AfterViewInit, Component } from '@angular/core';

import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'apm-card-wrapper',
  templateUrl: './card-wrapper.component.html',
  styleUrls: ['./card-wrapper.component.scss'],
  standalone: false,
})
export class CardWrapperComponent extends FieldWrapper implements AfterViewInit {
  fieldArrayProps: any;

  ngAfterViewInit() {
    if (this.field.fieldArray) {
      if (this.field.props) {
        this.fieldArrayProps = this.field.props;
      }
    } else {
      const childField = this.field?.fieldGroup?.find(f => f.fieldArray);
      if (childField?.props) {
        this.fieldArrayProps = childField.props;
      }
    }
  }
}
